import { IS_PROD } from "@/configs";
import { BingoSquare } from "@/types/bingo";

const BINGO_FORMS_PROD = {
  "creative-challenge": "LhDMO8Mz",
  "treasure-hunt-1": "hrGpegb9",
  "treasure-hunt-2": "hv9DY03i",
  "new-artist": "NNvYZlRd",
  "new-friend": "twWinGpi",
  "new-place": "C0as7rib",
  "artist-talk": "gvAaqLNl",
  "quiz-1": "NOGb94Ht",
  "quiz-2": "fm41cnCR",
}

// TODO: create forms for staging
const BINGO_FORMS_STAG = {
  "creative-challenge": null,
  "treasure-hunt-1": "EeOtMOtg",
  "treasure-hunt-2": null,
  "new-artist": null,
  "new-friend": null,
  "new-place": "qyhYmK37",
  "artist-talk": "TPU6hOWk",
  "quiz-1": null,
  "quiz-2": null,
};

export const BINGO_FORM_ID = IS_PROD ? BINGO_FORMS_PROD : BINGO_FORMS_STAG;

export const bingoSquares: BingoSquare[] = [
  {
    text: "Visit a Blockbuster Exhibition",
    type: "event",
    tag: "Blockbuster",
    color: "red",
  },
  {
    formId: BINGO_FORM_ID["creative-challenge"],
    text: "Get Creative!",
    type: "form",
    route: "/creative-challenge",
    color: "yellow",
  },
  {
    formId: BINGO_FORM_ID["treasure-hunt-1"],
    text: "Treasure Hunt #1",
    type: "form",
    route: "/treasure-hunt-1",
    color: "blue",
  },
  {
    text: "Go to an Art Fair",
    type: "event",
    tag: "Art Fair",
    color: "red",
  },
  {
    formId: BINGO_FORM_ID["quiz-1"],
    text: "Quiz #1",
    type: "form",
    color: "blue",
    route: "/quiz-1",
  },
  {
    text: "Go to a Museum Late",
    type: "event",
    tag: "Museum Late",
    color: "red",
  },
  {
    text: "Invite a friend to Nimi",
    type: "challenge",
    challengeType: "invite-friend",
    route: "/invite-friend",
    color: "green",
  },
  {
    formId: BINGO_FORM_ID["treasure-hunt-2"],
    text: "Treasure Hunt #2",
    type: "form",
    color: "blue",
    route: "/treasure-hunt-2",
  },
  {
    formId: BINGO_FORM_ID["new-artist"],
    text: "Discover a new favourite artist!",
    type: "form",
    route: "/new-artist",
    color: "green",
  },
  {
    formId: null,
    text: "Treasure Hunt #3",
    type: "form",
    color: "blue",
    route: null,
  },
  {
    text: "Visit an Alternative Exhibition",
    type: "event",
    tag: "Hidden Gem",
    color: "red",
  },
  {
    formId: BINGO_FORM_ID["new-friend"],
    text: "Make a new friend",
    type: "form",
    route: "/new-friend",
    color: "green",
  },
  {
    text: "Visit 3+ Exhibitions in a day",
    type: "event",
    tag: "Gallery Stroll",
    color: "red",
  },
  {
    formId: BINGO_FORM_ID["new-place"],
    text: "Visit a new place",
    type: "form",
    route: "/new-place",
    color: "green",
  },
  {
    formId: BINGO_FORM_ID["quiz-2"],
    text: "Quiz #2",
    type: "form",
    color: "blue",
    route: "/quiz-2",
  },
  {
    formId: BINGO_FORM_ID["artist-talk"],
    text: "Talk with an Artist",
    type: "form",
    route: "/artist-talk",
    color: "yellow",
  },
];
